/**
 * @Auth
 */
export const LOGIN = "v1/auth/login";
export const REGISTER = "v1/auth/register";
export const VERIFY_2FA = "v1/auth/verify-2fa";
export const REGENERATE_2FA = "v1/auth/regenerate-2fa-code";
export const VERIFY_ACCOUNT_API = "v1/auth/verify-account";
export const AUTH_0_API = "v1/auth/auth0";
export const FORGOT_PASSWORD = "v1/auth/forgot-password";
export const RESET_PASSWORD = "v1/auth/reset-password";
export const REFRESH_TOKENS_API = "v1/auth/refresh-tokens";
export const CHECK_AUTHORIZATION_API = "v1/auth/check-authorization";
export const VERIFY_TOTP_OTP = "v1/auth/verify-totp-otp";
export const TOTP_SETUP = "v1/auth/verify-totp-with-setup-login";
export const LOST_DEVICE = "v1/auth/lost-device";
export const VERIFY_TO_RESET_TOTP = "v1/auth/verify-to-reset-totp";

/**
 * @Customer_Profile
 */
export const USER_PROFILE = "v1/account/profile";
export const USER_PROFILE_IMAGE = "v1/account/profile-image";
export const CHANGE_PASSWORD = "v1/account/change-password";
export const CHANGE_MFA_STATUS = "v1/account/change-mfa-status";
export const TOTP_ENABLE_VERIFY = "v1/account/very-enable-totp";
export const REQUEST_DISABLE_MFA = 'v1/account/mfa-disable-request';
export const VERIFY_DISABLE_REQUEST = "v1/account/verify-disable-request";
export const ACCEPT_EULA = "v1/account/accept-eula";

/**
 * @app_users
 */
export const APP_USERS_LIST = "v1/users";
export const APP_USER_ADD = "v1/users/add";
export const APP_USER_EDIT = "v1/users/edit/";
export const APP_USER_GET = "v1/users/get/";
export const APP_USER_DELETE = "v1/users/delete/";
export const APP_CHANGE_STATUS = "v1/users/change-status/";
export const APP_USER_SEND_VERIFICATION = "v1/users/send-verification-email/";
export const SET_UP_PASSWORD = "v1/users/setup-password";
export const APP_USER_ROLES = "v1/users/role/list";
export const APP_USER_NOTIFICATIONS = "v1/users/notifications";
export const APP_USER_CLEAR_NOTIFICATIONS = "v1/users/notifications/clear";
export const APP_USER_MARK_NOTIFICATIONS_READ = "v1/users/notifications/read";

/**
 * @ROLES_AND_PERMISSION
 */
export const ROLES_ADD = "v1/roles/add";
export const ROLES_UPDATE = "v1/roles/update";
export const ROLES_LIST = "v1/roles/list";
export const ROLES_DETAILS = "v1/roles/get";
export const ROLES_AND_PERMISSION = "v1/roles/roles-permission";
export const ROLES_DELETE = "v1/roles/delete";
/**
 * @PROJECT OR @Site
 */
export const PROJECT_ADD = "v1/projects/add";
export const PROJECT_UPDATE = "v1/projects/update";
export const PROJECT_DELETE = "v1/projects/delete";
export const PROJECT_OR_SITE_LIST = "v1/projects/list";
export const PROJECT_DROPDOWN_LIST = "v1/projects/site-project-list";
export const SITE_UPLOAD_IMPORT_FILE = "v1/sites/upload-import-file";
export const SITE_CREATE = "v1/sites/create-site";
export const SITE_DELETE = "v1/sites/delete-site";
export const SITE_TEST_CREDENTIALS_CHECK_AUTH = "v1/sites/check-authentication";
export const SITE_CHECK_SESSION_REFRESH = "v1/sites/check-session-refresh";

export const SITE_SCRIPT_TEMPLATE = "v1/sites/script-template";
export const SITE_GENERATE_BUSINESS_LOGIC_STEPS = "v1/sites/business-logic/generate-steps";
export const SITE_DETAILS = "v1/sites/details";
export const SITE_UPDATE = "v1/sites/update-site";
export const SITE_RUN_SCAN_HISTORY = "v1/sites/run-scan";
export const SITE_RUN_DELTA_SCAN = "v1/sites/run-delta-scan";
export const SITE_LIST = "v1/sites/project-site-list";
export const UPDATE_OTP_REQUEST_STATUS = "v1/sites/update-otp-request-status";
export const SAVE_SCAN_REQUESTED_OTP= "v1/sites/save-scan-requested-otp";
export const GET_VIDEO_URL = "v1/sites/get-video-url";

/**
 * @Subscription
 */
export const SUBSCRIPTION_GET_PLANS_LIST = "v1/payment/get-plans";
export const CHECKOUT_SESSION = "v1/payment/create-checkout-session";
export const PAYMENT_LISTING = "v1/payment/get-transactions";

/**
 * @Scan_History
 */
export const SCAN_HISTORY_LISTING = "v1/sites/get-scan-history";
export const SCAN_HISTORY_DELETE = "v1/sites/delete-scan-history";
export const SCAN_HISTORY_DETAILS = "v1/sites/get-scan-details";
export const SCAN_HISTORY_STOP = "v1/sites/stop-scan-history";
export const SCAN_ALERTS_DETAILS = "v1/sites/get-scan-alerts";
export const SCAN_ALERT_RETEST_URL = "v1/sites/re-test-url";
export const SCAN_ISSUE_RESOLVED = "v1/sites/scan-alerts/issue-resolved";
export const GENERATE_REPORT_PDF = "v1/sites/generate-report-pdf";
export const GENERATE_DELTA_REPORT_PDF = "v1/sites/generate-delta-report-pdf";
export const AI_SCAN_ALERTS_DETAILS = "v1/sites/get-scan-alerts-data";
export const AI_SCAN_SUMMARY_DETAILS = "v1/sites/get-ai-scan-summary";
export const UPDATE_AI_SCAN_SUMMARY_DETAILS = "v1/sites/update-ai-scan-summary";
export const AI_ALERT_DATA = "v1/sites/get-ai-alert-data";
export const LAST_SCANNED_PROJECTS = "v1/sites/last-scanned-site-projects";
export const EXPORT_ALERTS = "v1/sites/export-alerts";


/**
 * @Dashboard
 */
export const DASHBOARD_DATA = "v1/dashboard";

/**
 * @Branding
 */
export const BRANDING_ASSETS = "v1/branding/assets";
export const BRANDING_LOGO = "v1/branding/logo";
export const BRANDING_COVER = "v1/branding/cover";
export const UPDATE_BRANDING_ASSETS_SETTING = "v1/branding/assets";


export const PROCESSORS_LIST = "v1/processor/list";

/**
 * @Request_LOA
 */
export const REQUEST_LOA_SUBMIT = "v1/request-loa/submit";

/**
 * @API_Integration
 */
export const API_TOKENS_LIST = "v1/api-integration/tokens";
export const API_TOKEN_GENERATE = "v1/api-integration/tokens";
export const API_TOKEN_REGENERATE = "v1/api-integration/tokens";
export const API_TOKEN_DELETE = "v1/api-integration/tokens";
export const API_TOKEN_CHANGE_STATUS = "v1/api-integration/tokens";
export const API_WEBHOOKS_LIST = "v1/api-integration/webhooks";
export const API_WEBHOOK_ADD = "v1/api-integration/webhooks";
export const API_WEBHOOK_DELETE = "v1/api-integration/webhooks";
export const API_WEBHOOK_TEST = "v1/api-integration/webhooks";
export const API_WEBHOOK_CHANGE_STATUS = "v1/api-integration/webhooks";